import { Box } from '@mui/material';
import {
    StyledDialog,
    StyledDialogContainer,
    StyledDialogTitle
} from '@/components/consent/StyledDialog';
import { SemiBold, SMRegular, TextMDSemiBold } from '@/typography/Typography';
import { PrimaryButtonStyle } from '@/pages/company/common/IntegrationDialog';

type GenerateOtpDialogProps = {
    open: boolean;
    onClose: () => void;
    email?: string;
    otpCode?: string;
};

export const GenerateOtpDialog = ({
    open,
    onClose,
    email,
    otpCode
}: GenerateOtpDialogProps) => {
    return (
        <StyledDialog open={open} onClose={onClose}>
            <StyledDialogContainer style={{ width: '400px' }}>
                <StyledDialogTitle>
                    <SemiBold>Generated OTP</SemiBold>
                    <SMRegular m={1}>
                        For internal debugging only. Do not share this OTP with
                        the employee.
                    </SMRegular>
                </StyledDialogTitle>

                <Box display="flex" flexDirection="column" gap={2} mb={3}>
                    <Box>
                        <SMRegular>Email</SMRegular>
                        <TextMDSemiBold>{email}</TextMDSemiBold>
                    </Box>
                    <Box>
                        <SMRegular>OTP Code</SMRegular>
                        <TextMDSemiBold>{otpCode}</TextMDSemiBold>
                    </Box>
                </Box>

                <Box display="flex" justifyContent="center">
                    <PrimaryButtonStyle onClick={onClose}>
                        Close
                    </PrimaryButtonStyle>
                </Box>
            </StyledDialogContainer>
        </StyledDialog>
    );
};
